import { type FC, memo } from "react";
import { useTranslation } from "react-i18next";
import RichTooltip from "~/common/components/RichTooltip/RichTooltip";
import Tag from "~/common/components/Tag/Tag";
import { Button, Typography } from "~/common/mui";
import { useBootstrapUrls } from "~/app/config/useAppConfig";
import { resolveBootstrapUrl } from "~/app/config/resolveBootstrapUrl";

interface DesignationProps {
  marketDesignation: string;
}

const ProductMMD: FC<DesignationProps> = (props) => {
  const { t } = useTranslation();
  const { marketDesignation } = props;
  const urls = useBootstrapUrls();
  const mmdUrl = resolveBootstrapUrl(urls?.mmdUrl);

  return (
    <RichTooltip
      content={<Typography>{t("product.mmd.tooltip.content")}</Typography>}
      actions={[
        <Button className="mt-3" href={mmdUrl} variant="text">
          {t("product.mmd.tooltip.readmore")}
        </Button>,
      ]}
    >
      <Tag iconPosition="start">{marketDesignation}</Tag>
    </RichTooltip>
  );
};

export default memo(ProductMMD);
